import React,{useEffect,useRef} from "react";
import {Box,Typography,Container} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import "./roadmap.css";
import {setupRoadmapAnimations} from "../animations/roadmapsAnimation";
import colors from "../../../../theme/colors";
import typography from "../../../../theme/typography";

const roadmapItems=[
  {
    quarter:"Q1 2025",
    title:"Platform Launch",
    points:[
      "Core Lottery System",
      "Smart Contract Integration",
      "Initial Game Suite"
    ]
  },
  {
    quarter:"Q2 2025",
    title:"Game Expansion",
    points:[
      "New Game Experiences",
      "Additional Betting Options",
      "Mobile Optimization"
    ]
  },
  {
    quarter:"Q3 2025",
    title:"Ecosystem Growth",
    points:[
      "Token Utilities",
      "Community Features",
      "Global Expansion"
    ]
  },
  {
    quarter:"Q4 2025",
    title:"Community & Beyond",
    points:[
      "Community Governance",
      "More Games",
      "Strategic Partnerships"
    ]
  }
];

const Roadmap=()=>{
  const theme = useTheme();
  const sectionRef=useRef(null);
  const stageRef=useRef(null);
  const trackRef=useRef(null);
  const itemRefs=useRef([]);
  const centerRef=useRef(null);

  useEffect(()=>{
    return setupRoadmapAnimations({
      sectionRef,
      stageRef,
      trackRef,
      itemRefs,
      roadmapItems
    });
  },[]);

  return(
    <Box
      ref={sectionRef}
      component="section"
      className="roadmap-section"
    >
      <Container 
        maxWidth={false}
        sx={{
          width: "100%",
          maxWidth: "1400px",
          mx: "auto",
          px: theme.custom["home-section-left-padding"],
          pt: theme.custom.layoutSizes.section.paddingTop,
          pb: theme.custom.layoutSizes.section.paddingBottom,
        }}
      >
        <Box 
          className="roadmap-header"
          sx={(theme) => ({
            ...(theme.typography.homeSection?.headerContainer || {}),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            mb: "40px",
          })}
        >
          <Typography
            component="p"
            className="roadmap-eyebrow"
            sx={(theme) => ({
              ...(theme.typography.homeSection?.eyebrow || {}),
              color: theme.custom.colors.home.brandRed,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&::before": {
                ...(theme.typography.homeSection?.eyebrow?.["&::before"] || {}),
                background: theme.custom.colors.home.brandRed,
              },
              "&::after": {
                ...(theme.typography.homeSection?.eyebrow?.["&::before"] || {}),
                background: theme.custom.colors.home.brandRed,
                content: '""',
                display: "block",
                marginLeft: { xs: "8px", md: "16px" },
              },
            })}
          >
            ROADMAP
          </Typography>

          <Typography
            component="h2"
            className="roadmap-heading"
            sx={(theme) => ({
              ...(theme.typography.homeSection?.heading || {}),
              color: theme.custom.colors.home.navyDark,
              textAlign: "center",
            })}
          >
            Our Journey Forward
          </Typography>

          <Typography 
            className="roadmap-description"
            sx={(theme) => ({
              ...(theme.typography.homeSection?.description || {}),
              color: "text.secondary",
              textAlign: "center",
              mx: "auto",
              maxWidth: "600px",
            })}
          >
            Follow the key milestones shaping the future of AutoBET
            as we build a transparent and engaging gaming ecosystem.
          </Typography>
        </Box>

      <Box
        ref={stageRef}
        className="roadmap-stage"
      >

        <Box
          ref={trackRef}
          className="roadmap-track"
        >
          <Box className="roadmap-line"/>

          {roadmapItems.map((item,index)=>(
            <Box
              key={item.quarter}
              ref={element=>{
                itemRefs.current[index]=element;
              }}
              className={`roadmap-item roadmap-item-${index} ${index % 2 === 0 ? 'roadmap-item-left' : 'roadmap-item-right'}`}
            >
              <Box className="roadmap-bullet">
                <Box className="roadmap-bullet-inner"/>
              </Box>

              <Box className="roadmap-card">
                <Typography className="roadmap-quarter" sx={{ color: colors.slate[500], fontFamily: typography.fontFamily }}>
                  {item.quarter}
                </Typography>

                <Typography className="roadmap-title" sx={{ color: colors.home.navyDeep, fontFamily: typography.h3.fontFamily }}>
                  {item.title}
                </Typography>

                <Box className="roadmap-points">
                  {item.points.map(point=>(
                    <Box
                      key={point}
                      className="roadmap-point"
                    >
                      <Box className="roadmap-check">
                        ✓
                      </Box>

                      <Typography className="roadmap-point-text" sx={{ color: colors.text.secondary, fontFamily: typography.fontFamily }}>
                        {point}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      </Container>
    </Box>
  );
};

export default Roadmap;